<script>
import Home from "@/components/home";
import Menu from "@/components/menu";
import Clients from "@/components/clients";
import Features from "@/components/features";
import Services from "@/components/services";
import About from "@/components/about";
import Pricing from "@/components/pricing";
import Testimonial from "@/components/testimonial";
import GetStarted from "@/components/getstarted";
import Contact from "@/components/contact";
import Footer from "@/components/footer";
import Switcher from "@/components/switcher";
import Whatsapp from "@/components/Whatsapp";
/**
 * Index-1 component
 */
export default {
  components: {
    Home,
    Menu,
    Features,
    Services,
    Clients,
    Whatsapp,
    About,
    Pricing,
    Testimonial,
    GetStarted,
    Contact,
    Footer,
    Switcher
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    }
  }
};
</script>
<template>
  <div>
    <Menu />
    <div v-scroll-spy>
      <Home /> 
      <Clients />
      <Features />
      <Services />
      <About />
      <Pricing />
      <Testimonial />
      <GetStarted />
      <Contact />
      <Footer />
      <Switcher />
      <Whatsapp />
    </div>
  </div>
</template>
<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>